// extracted by mini-css-extract-plugin
export const overview = "overview-module--overview--bDQ0E";
export const content = "overview-module--content--2UHPh";
export const inner = "overview-module--inner--3dAGy";
export const tags = "overview-module--tags--wF57u";
export const title = "overview-module--title--3Ok2C";
export const datetime = "overview-module--datetime--3ZzB1";
export const share = "overview-module--share--3nlFr";
export const facebook = "overview-module--facebook--yMZ9e";
export const twitter = "overview-module--twitter--tvxG4";
export const line = "overview-module--line--1I3HW";
export const mail = "overview-module--mail--2asM_";
export const clip = "overview-module--clip--1OqBX";
export const lead = "overview-module--lead--1IbzV";